// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";

const styleMapping = {
  Solid: "fas",
  Regular: "far",
  Brand: "fab",
};

/**
 * Font Awesome Icon Component
 */
export const IconFas = ({
  style,
  name,
  color = "primary",
  fontSize = 48,
  ...props
}) => {
  return (
    <span style={{ fontSize: fontSize + "px", color: color }}>
      <i className={`${styleMapping[style]} fa-${name}`}></i>
    </span>
  );
};

IconFas.propTypes = {
  /**
   * <b>What style should the button icon be ?</b> <br><br>
   * Search Icons here : https://fontawesome.com/v5.15/icons?d=gallery&p=2&s=brands,regular,solid&m=free <br><br>
   */
  color: PropTypes.string,
  fontSize: PropTypes.string,
  style: PropTypes.oneOf(["Solid", "Regular", "Brand"]),
  name: PropTypes.string.isRequired,
};

IconFas.defaultProps = {
  color: "#000000",
  fontSize: "48px",
  style: "Solid",
  name: "camera",
};

export default IconFas;
